import * as turf from '@turf/turf';
const LayerControls = (name) => require('../../controls').get(name);

import api from '../../api';
import translate from '../tools/translate';
import Dialog from './Dialog';
import { loading, unloading } from "../../shared";
import { ContextEnum } from '../../../enuns/context.enum';
import wellknown from 'wellknown';

class FuelStation extends Dialog {
    constructor(area) {
        api.general.log.action(ContextEnum.SelectTool, 'Camada de Postos de Abastecimento');
        const contexts: any[] = [
            { label: translate('Common.FuelStation'), context: 'FuelStation', mainLayer: true }
        ];

        const shape =
            area.layerType === 'circle'
                ? turf.buffer(area.layer.toGeoJSON(), area.layer.getRadius(), { units: 'meters' })
                : area.layer.toGeoJSON();

        super(translate("Common.FuelStation"), area, contexts, null, false);

        const wkt = wellknown.stringify(shape);
        let data = LayerControls("FuelStation").getLayer().options.remote.params;
        data.bbox = wkt;

        loading();
        api.fuelStation.download(data).then(() => {
            unloading();
        });
    }
}

export default FuelStation;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/FuelStation.js